import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";

export const useCorpDeungiRetry = async (id: string) => {
    const response = await axiosInstance.put(`${axiosPath.submitCorpDeungi}/${id}`);
    return response;
};
